import { IMFormModal, IMInputText } from '@insurancemenu/imenu-components-lib';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { EditExpectedGroupSizeModalStore } from 'store/pages/quote/add-employees/editExpectedGroupSizeModalStore';
import { ModalType } from '@insurancemenu/imenu-components-lib/dist/helpers/ModalsHelper';
import { EDIT_EXPECTED_GROUP_SIZE_MODAL_ID } from '../constants';

interface Props {
  modalStore: EditExpectedGroupSizeModalStore;
}

export const EditExpectedGroupSizeModal: React.FC<Props> = observer(({ modalStore }) => {
  const { form, isVisible, onClose } = modalStore;

  return isVisible ? (
    <IMFormModal
      title="Expected Number of Employees"
      subtitle="Enter the expected number of employees in the group. You will receive a notification when all employees have filled in their data."
      show={isVisible}
      onClose={onClose}
      formController={form}
      formId={EDIT_EXPECTED_GROUP_SIZE_MODAL_ID}
      formContent={<IMInputText label="Number of employees" name="groupSize" size="full" />}
      submitButtonText="Save"
      closeButtonText="Cancel"
      resetOnClose={false}
      modalType={ModalType.EMAIL}
    />
  ) : null;
});
